'use strict';

var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');
var _typeof = require('@babel/runtime/helpers/typeof');
Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = void 0;
var _regenerator = _interopRequireDefault(require('@babel/runtime/regenerator'));
var _asyncToGenerator2 = _interopRequireDefault(require('@babel/runtime/helpers/asyncToGenerator'));
var _slicedToArray2 = _interopRequireDefault(require('@babel/runtime/helpers/slicedToArray'));
var _react = _interopRequireWildcard(require('react'));
var _allFiles = require('@react-icons/all-files');
var _provider = require('../../provider');
var Styles = _interopRequireWildcard(require('./styles'));
var _address = require('../../utils/address');
var _jsxRuntime = require('react/jsx-runtime');
function _getRequireWildcardCache(nodeInterop) {
	if (typeof WeakMap !== 'function') return null;
	var cacheBabelInterop = new WeakMap();
	var cacheNodeInterop = new WeakMap();
	return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
		return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
	})(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
	if (!nodeInterop && obj && obj.__esModule) {
		return obj;
	}
	if (obj === null || (_typeof(obj) !== 'object' && typeof obj !== 'function')) {
		return { default: obj };
	}
	var cache = _getRequireWildcardCache(nodeInterop);
	if (cache && cache.has(obj)) {
		return cache.get(obj);
	}
	var newObj = {};
	var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	for (var key in obj) {
		if (key !== 'default' && Object.prototype.hasOwnProperty.call(obj, key)) {
			var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
			if (desc && (desc.get || desc.set)) {
				Object.defineProperty(newObj, key, desc);
			} else {
				newObj[key] = obj[key];
			}
		}
	}
	newObj['default'] = obj;
	if (cache) {
		cache.set(obj, newObj);
	}
	return newObj;
}
var WalletConnectButton = function WalletConnectButton(_ref) {
	var buttonClassName = _ref.buttonClassName;
	var _useState = (0, _react.useState)(false),
		_useState2 = (0, _slicedToArray2['default'])(_useState, 2),
		showMenu = _useState2[0],
		setShowMenu = _useState2[1];
	var _useState3 = (0, _react.useState)(false),
		_useState4 = (0, _slicedToArray2['default'])(_useState3, 2),
		recentlyCopied = _useState4[0],
		setRecentlyCopied = _useState4[1];
	var _useContext = (0, _react.useContext)(_provider.SeiWalletContext),
		connectedWallet = _useContext.connectedWallet,
		accounts = _useContext.accounts,
		setTargetWallet = _useContext.setTargetWallet,
		setShowConnectModal = _useContext.setShowConnectModal;
	var handleClickOutside = function handleClickOutside(event) {
		event.stopPropagation();
		setShowMenu(false);
	};
	(0, _react.useEffect)(
		function () {
			if (showMenu) {
				document.addEventListener('click', handleClickOutside);
			} else {
				document.removeEventListener('click', handleClickOutside);
			}
			return function () {
				document.removeEventListener('click', handleClickOutside);
			};
		},
		[showMenu]
	);
	var changeWallet = function changeWallet() {
		setShowMenu(false);
		setShowConnectModal(true);
	};
	var copyAddress = /*#__PURE__*/ (function () {
		var _ref2 = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee() {
				var _accounts$;
				return _regenerator['default'].wrap(function _callee$(_context) {
					while (1)
						switch ((_context.prev = _context.next)) {
							case 0:
								setRecentlyCopied(true);
								_context.next = 3;
								return navigator.clipboard.writeText(
									accounts === null || accounts === void 0 || (_accounts$ = accounts[0]) === null || _accounts$ === void 0 ? void 0 : _accounts$.address
								);
							case 3:
								setTimeout(function () {
									setRecentlyCopied(false);
								}, 1500);
							case 4:
							case 'end':
								return _context.stop();
						}
				}, _callee);
			})
		);
		return function copyAddress() {
			return _ref2.apply(this, arguments);
		};
	})();
	var disconnect = function disconnect() {
		if (setTargetWallet) setTargetWallet(undefined);
	};
	var renderButton = function renderButton() {
		if (!connectedWallet) {
			return /*#__PURE__*/ (0, _jsxRuntime.jsx)('button', {
				'data-testid': 'connect-wallet',
				className: buttonClassName,
				onClick: function onClick() {
					return setShowConnectModal(true);
				},
				children: 'connect wallet'
			});
		}
		var accountLabel =
			(accounts === null || accounts === void 0 ? void 0 : accounts[0]) === undefined ? 'connecting...' : (0, _address.truncateAddress)(accounts[0].address);
		return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.ConnectWrapper, {
			children: [
				/*#__PURE__*/ (0, _jsxRuntime.jsx)('button', {
					disabled: showMenu,
					className: buttonClassName,
					onClick: function onClick(e) {
						e.stopPropagation();
						setShowMenu(true);
					},
					children: accountLabel
				}),
				showMenu &&
					/*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.WalletMenu, {
						children: [
							accounts &&
								/*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.WalletMenuItem, {
									'data-testid': 'copy-address',
									onClick: copyAddress,
									children: [
										/*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.WalletMenuItemCopy, {}),
										/*#__PURE__*/ (0, _jsxRuntime.jsx)('span', {
											children: recentlyCopied ? 'copied' : 'copy address'
										})
									]
								}),
							/*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.WalletMenuItem, {
								'data-testid': 'change-wallet',
								onClick: changeWallet,
								children: [
									/*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.WalletMenuItemChange, {}),
									/*#__PURE__*/ (0, _jsxRuntime.jsx)('span', {
										children: 'change wallet'
									})
								]
							}),
							/*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.WalletMenuItem, {
								'data-testid': 'disconnect-button',
								onClick: disconnect,
								children: [
									/*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.WalletMenuItemLogOut, {}),
									/*#__PURE__*/ (0, _jsxRuntime.jsx)('span', {
										children: 'disconnect'
									})
								]
							})
						]
					})
			]
		});
	};
	return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_allFiles.IconContext.Provider, {
		value: {
			color: '#121212',
			size: '50px'
		},
		children: renderButton()
	});
};
var _default = (exports['default'] = WalletConnectButton);
//# sourceMappingURL=WalletConnectButton.js.map
